/**
 * Zajedničko za mobilne ekrane firme "više restorana". Ekrani nasleđuju računarske ekrane (a oni stari tab), pa
 * učitavanje, računanje, štampa i Excel su isti; ovde je samo ono što šablon za telefon koristi: pretraga iz
 * zaglavlja ljuske i zaokruživanje iznosa.
 */
export default {
  computed: {
    filters() {
      return this.$store.state.report.filters;
    },
    searchText() {
      return String(this.filters.search || "");
    },
  },
  methods: {
    money(value) {
      return (Number(value) || 0).toFixed(2);
    },
  },
};
